module.exports = __webpack_public_path__ + "ie.a27b6532c14fb927762a.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/ie.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/ie.svg
// module chunks = styles